import React from 'react';
import { GetPeers } from '../../containers/rtc/PeersContext';
import { createStyles } from '../../utils/css';
import { GetPeersPlayback } from '../../containers/rtc/PeersPlaybackContext';
import MediaElement, { MediaType } from './MediaElement';
import { CallStateConsumer, CallStage } from 'app/containers/call/CallStateContext';

/**
 * Plays audio for each peer in hidden audio elements
 */
const PeersAudio = () =>
  <CallStateConsumer>{({ stage }) => stage === CallStage.Active &&
    <GetPeersPlayback>{(playback) => playback &&
      <Styles>{(css) =>
        <div className={css('peersAudio')}>
          <GetPeers>{(peers) => peers.valueSeq().filter(({ audioStream }) => !!audioStream).map(({ id, audioStream }) =>
            audioStream && <MediaElement<MediaType.Audio>
              type={MediaType.Audio}
              key={id}
              src={audioStream}
              playback={playback}
            />,
          )}</GetPeers>
        </div>
      }</Styles>
    }</GetPeersPlayback>
  }</CallStateConsumer>;

const Styles = createStyles({
  peersAudio: {
    display: 'none',
  },
});

export default PeersAudio;
